import React, { useState, useEffect } from 'react';
import CommonCheckbox from '../../../components/CommonCheckBox/CommonCheckbox';
import DashboardDateFilter from '../../../../components/DashboardDateFilter/DashboardDateFilter';
import moment from 'moment';
import RadioButton from '../../../../components/Dashboard-res/CommonComponent/RadioButton';
const CallMade = ({
  masterFilter,
  updateFilters,
  doReset,
  updateSelectionFieldsInHTMLFormatForDeSelect
}) => {
  const [date, setDate] = useState('today');
  const [startDate, setStartDate] = useState(
    masterFilter?.callMade?.startDate ||
      moment()
        .subtract('month', 1)
        .format('YYYY-MM-DD')
  );
  const [toDate, setToDate] = useState(
    masterFilter?.callMade?.toDate || moment().format('YYYY-MM-DD')
  );

  const handleDate = day => {
    if (day == 'today') {
      setStartDate(moment().toDate());
      setToDate(moment().toDate());
    } else if (day == 'yesterday') {
      setStartDate(
        moment()
          .subtract('day', '1')
          .toDate()
      );
      setToDate(
        moment()
          .subtract('day', '1')
          .toDate()
      );
    }

    setDate(day);
  };

  useEffect(() => {
    updateFilters({
      key: 'callMade',
      filters: {
        startDate: startDate,
        toDate: toDate
      }
    });

    updateSelectionFieldsInHTMLFormatForDeSelect({
      key: 'callMade',
      object: {
        startDate: {
          name: `From Date-${moment(startDate).format('YYYY-MMM-DD')}`,
          value: startDate
        },
        toDate: {
          name: `To Date-${moment(toDate).format('YYYY-MMM-DD')}`,
          value: toDate
        }
      },
      handleCancel: handleCancel,
      displayName: 'name'
    });
  }, [startDate, toDate]);

  const handleCancel = e => {
    setStartDate(e?.startDate?.value || moment().toDate());
    setToDate(e?.toDate?.value || moment().toDate());
  };

  useEffect(() => {
    if (doReset) {
      setStartDate(
        moment()
          .subtract('month', 1)
          .format('YYYY-MM-DD')
      );
      setToDate(moment().format('YYYY-MM-DD'));
    }
  }, [doReset]);

  const checkDateDiff = (startDay, endDay) =>
    moment(startDate).isSame(moment().subtract('day', startDay), 'day') &&
    moment(toDate).isSame(moment().subtract('day', endDay), 'day');

  useEffect(() => {
    if (checkDateDiff('0', '0')) setDate('today');
    else if (checkDateDiff('1', '1')) setDate('yesterday');
    else setDate('custom');
  }, [startDate, toDate]);

  return (
    <div className="w-full">
      <p className="font-roboto font-medium text-base">Call Made on Filter</p>
      <div className={`w-full mt-4 flex `}>
        <div className="flex ">
          <RadioButton
            checked={date == 'today' ? true : false}
            onChange={() => handleDate('today')}
          />
          <p className="text-grey-2234 font-roboto text-sm ml-1">Today</p>
        </div>
        <div className="flex  ml-7">
          <RadioButton
            checked={date == 'yesterday' ? true : false}
            onChange={() => handleDate('yesterday')}
          />
          <p className="text-grey-2234 font-roboto text-sm  ml-1">Yesterday</p>
        </div>
        <div className="flex ml-7">
          <RadioButton
            checked={date == 'custom' ? true : false}
            onChange={() => handleDate('custom')}
          />
          <p className="text-grey-2234 font-roboto text-sm ml-1">Custom</p>
        </div>
      </div>
      <div className={`w-11/12 flex  mt-7 md:absolute relative`}>
        <DashboardDateFilter
          getValuesByProps={true}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={toDate}
          setEndDate={setToDate}
        />
      </div>
    </div>
  );
};
export default CallMade;
